import moment from 'moment';
import { createReducer } from 'typesafe-actions';
import withJobs from '../../_core/job/reducers';
import {
    IBFL1Store,
} from './@types';
import bfl1Actions, { EBFL1Constants, TBFL1Actions } from './actions';

const defaultState: IBFL1Store = {
    _jobs: {},
    currentOperation: undefined,
    records: {
        byIds: {},
        ids: [],
    },
    filter: {
        startDate: moment().subtract(7, 'days').toDate(),
        endDate: moment().add(1, 'day').toDate(),
        shownRecords: 'ALL',
    },
};
const bfl1Reducers = createReducer<IBFL1Store, TBFL1Actions>(defaultState)
    .handleAction(
        bfl1Actions.document.historySet,
        function historySet(state, action) {
            return {
                ...state,
                records: action.payload.history,
            };
        }
    )
    .handleAction(
        bfl1Actions.document.setFilter,
        function setFilter(state, action) {
            return {
                ...state,
                filter: action.payload.filter,
            };
        }
    );

export default withJobs<IBFL1Store>(
    EBFL1Constants.FEATURE,
    defaultState,
    bfl1Reducers
);
